import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class Associateandpartners extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    this.loadscript()
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }
  render() {
    const { } = this.state;
    return (
      <>
        <StaticHeader />
        <>
          <div className="website">
            <section className="banner page-banner position-relative pb-0">
              <div className="overlay"></div>
              <div className="container">
                <div className="page-title text-center position-relative py-9">
                  <h2 className="text-white text-uppercase mt-4">Associates and PARTNERS</h2>
                </div>
              </div>
            </section>
            <section className="conference">
              <div className="container">
                <div className="partner-inner">
                  <div className="partner-title text-center pb-6 w-lg-60 m-auto">


                  </div>
                  <div className="partner-img pb-6">
                    <div className="row row-cols-1 row-cols-lg-5 row-cols-md-5 ">
                      <div className="col p-0 border-end border-sm-0">
                        <div className="p-2 partner-img-box text-center">
                          <img
                            src="static/images/Partner-logo/1.jpg"
                            alt="partner-img"
                            className="opacity-75 w-lg-75 w-md-100 w-40"
                          />
                        </div>
                      </div>
                      <div className="col p-0 border-end border-sm-0">
                        <div className="p-2 partner-img-box text-center ">
                          <img
                            src="static/images/Partner-logo/2.jpg"
                            alt="partner-img"
                            className="opacity-75 w-lg-75 w-md-100 w-40"
                          />
                        </div>
                      </div>
                      <div className="col p-0 border-end border-sm-0">
                        <div className="p-2 partner-img-box text-center">
                          <img
                            src="static/images/Partner-logo/3.jpg"
                            alt="partner-img"
                            className="opacity-75 w-lg-75 w-md-100 w-40"
                          />
                        </div>
                      </div>
                      <div className="col p-0 border-end border-sm-0">
                        <div className="p-2 partner-img-box text-center">
                          <img
                            src="static/images/Partner-logo/4.jpg"
                            alt="partner-img"
                            className="opacity-75 w-lg-75 w-md-100 w-40"
                          />
                        </div>
                      </div>
                      <div className="col p-0 border-sm-0">
                        <div className="p-2 partner-img-box text-center">
                          <img
                            src="static/images/Partner-logo/5.jpg"
                            alt="partner-img"
                            className="opacity-75 w-lg-75 w-md-100 w-40"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </section>
          </div>
        </>

        <StaticFooter />
        <ToastContainer />
      </>
    )
  }
}
export default withRouter(
  connect(null, {})(Associateandpartners)
);
